import { useState } from 'react';
import { Clamp } from '../../helpers';
import { CustomerDetails, InvoiceDownload } from '../../components';
import ResursPaymentMethods from './ResursPaymentMethods';
import ResursPayForm from './ResursPayForm';
import { IInvoice } from '../../interfaces';

type Props = {
    invoice: IInvoice;
};

export default function ResursCheckout({ invoice }: Props) {
    const paymentMethods = invoice.payment_methods ?? [];
    const firstId = paymentMethods[0]?.id ?? null;
    const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState<string | null>(firstId);

    return (
        <Clamp>
            <CustomerDetails />
            <InvoiceDownload invoice={invoice} />
            <ResursPaymentMethods
                totalAmount={invoice.total_amount}
                selectedId={selectedPaymentMethodId}
                paymentMethods={paymentMethods}
                onSelect={setSelectedPaymentMethodId}
            />
            {selectedPaymentMethodId && (
                <ResursPayForm
                    invoice={invoice}
                    paymentMethodId={selectedPaymentMethodId}
                />
            )}
        </Clamp>
    );
}
